import Validation from "utils/validation.utils";
import locale from "localization";
import moment from "moment";
const initialState = (keyAccount) => {
  return {
    date: {
      name: "date",
      value: keyAccount?.depositedAt ? moment(keyAccount?.depositedAt).toDate() : new Date(),
      label: locale.date,
      required: true,
      validations: [Validation.required()],
    },
    time: {
      name: "time",
      value: keyAccount?.depositedAt ? moment(keyAccount?.depositedAt).toDate() : new Date(),
      label: locale.time,
      placeholder: locale.setTime,
      required: true,
      validations: [Validation.required()],
    },
    shiftId: {
      name: "shiftId",
      value: keyAccount?.shift?.shiftId,
      label: locale.selectShift,
      placeholder: locale.selectShift,
      required: true,
      validations: [Validation.required()],
      disableAllOption: true,
    },
    amount: {
      name: "amount",
      value: keyAccount?.amount || "",
      label: locale.amount,
      required: true,
      isPriceValue: true,
      innerLabel: true,
      min: 1,
      max: 9999999999999.99,
      placeholder: "0.00",
      validations: [Validation.required(), Validation.min(1)],
    },
    remarks: {
      name: "remarks",
      value: keyAccount?.remarks || "",
      label: locale.remarks,
      placeholder: locale.enterRemarks,
      maxLength: 500,
    },
    siNumber: {
      name: "siNumber",
      value: keyAccount?.siNumber || "",
      label: locale.siNumSoa,
      placeholder: locale.enterSiNumSoa,
      required: true,
      maxLength: 20,
      validations: [Validation.required()],
    },
    keyAccountId: {
      name: "keyAccountId",
      value: keyAccount?.keyAccountId || "",
      label: "",
      placeholder: locale.enterSiNumSoa,
      required: true,
      maxLength: 20,
      validations: [Validation.required()],
    },
    paymentMethod: {
      name: "paymentMethod",
      value: keyAccount?.paymentMethod || "",
      label: locale.depositType,
      placeholder: locale.selectPaymentMethod,
      required: true,
      validations: [Validation.required()],
    },
    referenceNumber: {
      name: "referenceNumber",
      value: keyAccount?.referenceNumber || "",
      label: locale.referenceNumber,
      placeholder: locale.enterReferenceNumber,
      required: true,
      maxLength: 20,
      validations: [Validation.required()],
    },
  };
};

export default initialState;
